import React from 'react';
import Seo from '../components/hoc/components/seo/seo';
import Home from '../components/domains/home';
import { BannerLayout } from '../components/hoc/components/layout/banner-layout';
import useTranslation from '../hooks/useTranslation';

const Landing = () => {
	const { t } = useTranslation();
	return (
		<BannerLayout
			label= {t('pages.welcome.label')}
			title={t('pages.welcome.title')}
			mlrVersion={t('pages.welcome.mlrVersion')}>
			<Home />
		</BannerLayout>
	);
};

export default Landing;

export function Head() {
	return <Seo />;
}
